// Whether the Play Store row has been dismissed on this device. Dismissal is
// permanent: there is no re-show timer, because the row asks for an install and
// a second ask after a no reads as nagging.

const KEY = 'playPromoDismissed'

export function isPlayPromoDismissed() {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function dismissPlayPromo() {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    /* ignore */
  }
}

/**
 * Whether the Play Store row belongs on screen. `isApp` alone is not enough:
 * it is false in a desktop browser too, where an Android install link is noise.
 */
export function shouldShowPlayPromo({ url, isApp, userAgent, dismissed, hasHistory }) {
  return Boolean(url)
    && !isApp
    && /Android/i.test(userAgent || '')
    && !dismissed
    && hasHistory
}
